import { Routes, Route, matchPath, useLocation } from 'react-router-dom';

import { RequiresAuth } from '~/components/Auth';
import { Layout } from '~/components/Layout';

import routes from '../config/routesConfig';
import type { TMicroAppDetails } from '../types';

import NoRemoteRouteMatched from './NoMatchingRoute';
import { useCallback } from 'react';
import { ROUTES_NAMESPACE } from '~/config/app.constants';
import LegacyAppRouting from '~/components/LegacyAppRouting';
import { isAdminSite } from '~/utils';
import { ROUTE_TYPES } from '../config/constants';
import { renderRoutes } from '../helpers';
const noLayoutRoutes =
  routes.protectedRoutes.filter((route: TMicroAppDetails) => route.layout === false) || [];

const ProtectedRoutes = () => {
  const location = useLocation();
  const hideLayout = useCallback(
    () =>
      noLayoutRoutes.some(({ path }) => {
        if (!path) {
          return false;
        }
        const namespaces = Array.isArray(ROUTES_NAMESPACE) ? ROUTES_NAMESPACE : [ROUTES_NAMESPACE];
        return namespaces.some(ns => !!matchPath(`/${ns.replace('*', path)}`, location.pathname));
      }),
    [location]
  );
  return (
    <RequiresAuth>
      <Layout hideLayout={hideLayout}>
        <Routes>
          {renderRoutes(routes, ROUTE_TYPES.protectedRoutes)}
          {!isAdminSite() && <Route path="learner/*" element={<LegacyAppRouting />} />}
          <Route path="*" element={<NoRemoteRouteMatched />} />
        </Routes>
      </Layout>
    </RequiresAuth>
  );
};

export default ProtectedRoutes;
